var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.83 3.742a1.25 1.25 0 0 0-1.66 0l-7 6.222a1.25 1.25 0 0 0-.42.934V19c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2a2.75 2.75 0 1 1 5.5 0v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-8.102a1.25 1.25 0 0 0-.42-.934zM10.174 2.62a2.75 2.75 0 0 1 3.654 0l7 6.222a2.75 2.75 0 0 1 .923 2.055V19A2.75 2.75 0 0 1 19 21.75h-3A2.75 2.75 0 0 1 13.25 19v-2a1.25 1.25 0 1 0-2.5 0v2A2.75 2.75 0 0 1 8 21.75H5A2.75 2.75 0 0 1 2.25 19v-8.102c0-.785.336-1.533.923-2.055z",
    clipRule: "evenodd"
  })));
};
export default SvgHouse;